// extracted by mini-css-extract-plugin
module.exports = {"summary__item":"J_cK","summary__item__name":"J_cL","summary__item__price":"J_cM","summary__col__wrap":"J_cN","summary__quantity":"J_cP"};